import { SUPPORTED_SYMBOLS } from '@/types/domain';

/** Конвертирует Gate-формат `BTC_USDT` в `BTCUSDT`. */
function fromGateUnderlying(name: string): string {
  return name.replaceAll('_', '');
}

/**
 * Получить актуальный список underlying опционов на Gate.io.
 * Использует публичный CORS-friendly endpoint напрямую из браузера.
 * При ошибке возвращает константу SUPPORTED_SYMBOLS как фолбэк.
 */
export async function listUnderlyings(): Promise<string[]> {
  try {
    const r = await fetch('https://api.gateio.ws/api/v4/options/underlyings');
    if (!r.ok) return [...SUPPORTED_SYMBOLS];
    const data = (await r.json()) as Array<{ name: string; index_price: string }>;
    const fromApi = data.map((u) => fromGateUnderlying(u.name));
    // Объединяем с SUPPORTED_SYMBOLS, чтобы все нужные тикеры всегда отображались.
    const merged = [...new Set([...SUPPORTED_SYMBOLS, ...fromApi])];
    return merged;
  } catch {
    return [...SUPPORTED_SYMBOLS];
  }
}
